import React, { Component } from 'react';
import _ from 'lodash';

import MpaParkinglocationTable from '../components/MpaParkinglocationTable';
import MpaParkinglocationForm from '../components/MpaParkinglocationForm';

import MpaParkinglocationModel from '../components/MpaParkinglocationModel';

import { Layout, Button, Row, Col, Input, Icon, message } from 'antd';

class MpaParkinglocationsScreen extends Component {

  state = {    
    dataLoading: true,
    dataAll: [],
    data: [],              
    parkinglocationFormModalVisible: false,    
  }

  componentWillMount() {
    this.loadData();
  }

  loadData(force = false) {
    this.setState({
      dataLoading: true
    });
    MpaParkinglocationModel.getAll(force)
      .then(data => {        
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });   
      })
      .catch(err => {
        message.warning('Lokality se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,          
        });
      });
  }

  onSearch(searchText) {        
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => { return d['ParkingLocationName'].startsWith(searchText); })
    })
  }

  render() {
    return (      
      <Layout.Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>MPA - Seznam lokalit</h2>
          <div style={{marginBottom: '20px'}}>
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="Název lokality"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} offset={8} style={{textAlign: 'right'}}>
                <Button type="default" onClick={() => { this.loadData(true) }} style={{marginRight: 10}}><Icon type="sync" /></Button>
                <Button type="default" onClick={() => { this.setState({parkinglocationFormModalVisible: true}) }}>Nová lokalita</Button>
              </Col>
            </Row>          
          </div>
          <MpaParkinglocationForm 
            type="modal" 
            modalVisible={this.state.parkinglocationFormModalVisible} 
            onModalCancel={()=>{this.setState({ parkinglocationFormModalVisible: false })}}
            onSuccess={(form, values) => { 
              MpaParkinglocationModel.create(values)
                .then(() => {
                  form.resetFields(); 
                  this.loadData(true);
                });                            
            }} />
          <MpaParkinglocationTable
            data={this.state.data} 
            loading={this.state.dataLoading}
            onRemoveRow={(id)=>{
              MpaParkinglocationModel.remove(id)
                .then(() => {
                  this.loadData(true);
                });                                          
            }}/>            
        </div>
      </Layout.Content>
    );
  }
}

export default MpaParkinglocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/MpaParkinglocationsScreen.js